import classNames from 'classnames';
import styles from './header.module.scss';

interface IStoreHeaderProps {
  title: string;
  address: string;
  image: string;
}

export default function StoreHeader({
  title,
  address,
  image,
}: IStoreHeaderProps) {
  return (
    <div
      className={classNames(
        styles['store-header'],
        'd-flex align-items-center',
      )}
    >
      <div>
        <img src={image} alt={title} className="rounded-circle" />
      </div>
      <div className="me-3">
        <h4>{title}</h4>
        <div className="d-flex align-items-center">
          <i className="icon-location fs-5 color-primary ps-2"></i> {address}
        </div>
      </div>
    </div>
  );
}
